import * as React from "react";

const LinkedIn: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.20001 4.99891C8.20001 6.08165 7.4157 6.99782 6.1608 6.99782C4.98433 6.99782 4.20001 6.08165 4.20001 4.99891C4.20001 3.87452 4.98433 3 6.20001 3C7.4157 3 8.1608 3.87452 8.20001 4.99891ZM4.5004 18.948V8H7.9724V19L4.5004 18.948ZM10.0004 11.388C10.0004 9.984 10.0364 9.008 10.0004 8H12.8291L13.0124 9.372H13.0844C13.5164 8.652 14.6324 7.7 16.5044 7.7C18.8084 7.7 20.5004 9.264 20.5004 12.54V19H17.0004V12.7968C17.0004 11.3568 16.5404 10.38 15.2804 10.38C14.3444 10.38 13.8764 11.028 13.6244 11.676C13.5164 11.892 13.5164 12.216 13.5164 12.54V19H10.0004V11.388Z" fill="currentColor" />
        </svg>
    );
};

export default React.memo(LinkedIn);
